(function () {
  function parseEndTime(endStr) {
    if (!endStr || !String(endStr).trim()) return NaN;
    var s = String(endStr).trim();
    if (/^\d{4}-\d{2}-\d{2}\s+\d{1,2}:\d{2}(:\d{2})?$/.test(s)) {
      s = s.replace(/\s+/, 'T');
      if (s.indexOf(':', s.indexOf('T') + 1) === s.lastIndexOf(':')) {
        s += ':00';
      }
    }
    return Date.parse(s);
  }

  function initCountdown(root) {
    if (root.__bfCountdownTimer) {
      window.clearTimeout(root.__bfCountdownTimer);
      root.__bfCountdownTimer = null;
    }

    var end = root.getAttribute('data-countdown-end');
    var display = root.querySelector('[data-bf-countdown-display]');
    if (!end || !display) return;

    var endTime = parseEndTime(end);
    if (Number.isNaN(endTime)) return;

    function tick() {
      var remaining = endTime - Date.now();
      if (remaining <= 0) {
        display.textContent = 'Offer ended';
        return;
      }
      var totalSeconds = Math.floor(remaining / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      display.textContent = days + 'd ' + hours + 'h ' + minutes + 'm left';
      root.__bfCountdownTimer = window.setTimeout(tick, 1000);
    }

    tick();
  }

  function initAll(scope) {
    var node = scope || document;
    node.querySelectorAll('[data-bf-promo]').forEach(initCountdown);
    if (node.matches && node.matches('[data-bf-promo]')) {
      initCountdown(node);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
